import React from 'react';
import PropTypes from 'prop-types';
import './AppWrapper.scss';
import { isTouchFriendly } from 'utils';

const AppWrapper = ({ children, style }) => {
  return (
    <div className="AppWrapper">
      <div
        className={`AppWrapper__Content ${isTouchFriendly ? 'mobile' : 'desktop'}`}
        style={style}
      >
        {children}
      </div>
    </div>
  );
};

AppWrapper.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
};
AppWrapper.defaultProps = {
  children: null,
  style: {},
};

export default AppWrapper;
